import { Dimensions } from 'react-native';

import { SizeBreakpoint } from '../enums/size-breakpoint';

export const isBigScreen = () =>
  Dimensions.get('window').width > SizeBreakpoint.MD;

export const breakpoint = (breakpoint: SizeBreakpoint) =>
  Dimensions.get('window').width >= breakpoint;

export function mediaQueryValues() {
  let extraSmall = 12;
  let small = 16;
  let medium = 24;
  let large = 32;
  let extraLarge = 40;

  let extraSmallImage = 90;
  let smallImage = 150;
  let mediumImage = 200;
  let largeImage = 250;
  let extraLargeImage = 267;
  let video = 235;

  if (isBigScreen()) {
    extraSmall = 16;
    small = 24;
    medium = 32;
    large = 40;
    extraLarge = 48;

    extraSmallImage = 154;
    smallImage = 257;
    mediumImage = 264;
    largeImage = 314;
    extraLargeImage = 545;
    video = 480;
  }
  return {
    video,
    extraSmall,
    small,
    medium,
    large,
    extraLarge,
    extraSmallImage,
    smallImage,
    mediumImage,
    largeImage,
    extraLargeImage,
  };
}
